<h2 mat-dialog-title>
  {{ 'CHANGE_PLAN_DIALOG.CHANGE_PLAN' | translate }}
</h2>
<span *ngIf="appConfig$ | async as config">
  <div class="change-plan" *ngIf="changePlanData.currentPlan$ | async as currentPlan; else loading">
    <mat-dialog-content>
      <div class="change-plan-details">
        <p [innerHTML]="changePlanData.moreDetailsMessageHTML"></p>
      </div>
      <div *ngIf="config.userCanAccessAccounts" class="change-plan-options">
        <mat-radio-group (change)="updatePlanSelected($event.value); confirmCheck = false">
          <mat-radio-button
            class="change-plan-option"
            color="primary"
            *ngFor="let planOption of changePlanData.options"
            [value]="planOption.value"
            [checked]="planOption.value === currentPlan.value"
          >
            {{ planOption.name }}
            <span *ngIf="planOption.value === currentPlan.value" style="font-size: 12px">
              <i>
                {{ 'CHANGE_PLAN_DIALOG.CURRENT_PLAN_HINT' | translate }}
              </i>
            </span>
          </mat-radio-button>
        </mat-radio-group>
      </div>
    </mat-dialog-content>
    <div *ngIf="config.userCanAccessAccounts; else cannotChange" class="confirm-change-plan-checkbox">
      <mat-checkbox
        color="primary"
        [disabled]="!chosenPlanValue || currentPlan.value === chosenPlanValue"
        [(ngModel)]="confirmCheck"
      >
        {{ 'CHANGE_PLAN_DIALOG.DISCLAIMER' | translate }}
      </mat-checkbox>
    </div>
    <ng-template #cannotChange>
      <div class="change-plan-details">
        {{ 'CHANGE_PLAN_DIALOG.YOU_DO_NOT_HAVE_PERMISSION' | translate }}
        <br />
        {{ 'CHANGE_PLAN_DIALOG.CONTACT_AN_ADMIN' | translate }}
      </div>
    </ng-template>
    <mat-dialog-actions>
      <button mat-button color="primary" (click)="close()">CANCEL</button>
      <button
        mat-raised-button
        color="primary"
        *ngIf="config.userCanAccessAccounts"
        (click)="submit(chosenPlanValue)"
        [disabled]="!confirmCheck"
      >
        CHANGE
      </button>
    </mat-dialog-actions>
  </div>
</span>
<ng-template #loading>
  <mat-spinner [diameter]="50"></mat-spinner>
</ng-template>
